import { WidgetInfo } from './WidgetInfo';
import { WidgetInfoLoader } from './WidgetInfoLoader';

export const WidgetInfoSection = (): JSX.Element => {
   return (
      <WidgetInfoLoader>
         {({ widgetInfo }) => (
            <WidgetInfo
               scriptHtmlTag={widgetInfo.scriptHtmlTag}
               installationManualLink={widgetInfo.installationManualLink}
            />
         )}
      </WidgetInfoLoader>
   );
};
